import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, Box, Spinner, Badge } from '@chakra-ui/react';
import map from 'lodash/map';
import Pagination from '../../common/UIcomponents/Pagination';
import ScrollToTop from '../../util/scrollToTop';
import CostCategoryEdit from './CostCategoryEdit';
import CostCategoryRemove from './CostCategoryRemove';
import SortArrows from '../../common/UIcomponents/SortArrowsTable';

function CostCategoryList({
  loading,
  categories,
  handlePageSizeChange,
  handlePageChange,
  currentPage,
  pagesQuantity,
  updateCategory,
  removeCategory,
  orderBy,
  updateOrderBy,
}) {
  const { code, name, enabled } = orderBy;

  function handleOnClick(e, key, value) {
    updateOrderBy(key, value);
  }

  return (
    <>
      <ScrollToTop />
      <Table
        variant="simple"
        bg="#fff"
        borderRadius="md"
        boxShadow="0 1px 13px rgba(29, 44, 45, 0.12);"
        mt="7"
      >
        {categories.length > 0 && !loading && (
          <Thead>
            <Tr key={'head-cost-categories'}>
              <Th maxWidth="100px">
                <Box
                  d="flex"
                  flexDirection="row"
                  alignItems="center"
                  color="#bdc1d0"
                  fontSize="12px"
                  fontFamily="Roboto"
                  letterSpacing="0"
                >
                  Code
                  <Box d="flex" flexDirection="column" ml="0px">
                    <SortArrows
                      i={code}
                      b="code"
                      desc="desc"
                      asc="asc"
                      handleOnClick={handleOnClick}
                    />
                  </Box>
                </Box>
              </Th>
              <Th>
                <Box
                  d="flex"
                  flexDirection="row"
                  alignItems="center"
                  color="#bdc1d0"
                  fontSize="12px"
                  fontFamily="Roboto"
                  letterSpacing="0"
                >
                  Name
                  <Box d="flex" flexDirection="column" ml="0px">
                    <SortArrows
                      i={name}
                      b="name"
                      desc="desc"
                      asc="asc"
                      handleOnClick={handleOnClick}
                    />
                  </Box>
                </Box>
              </Th>
              <Th>
                <Box
                  d="flex"
                  flexDirection="row"
                  alignItems="center"
                  color="#bdc1d0"
                  fontSize="12px"
                  fontFamily="Roboto"
                  letterSpacing="0"
                >
                  Status
                  <Box d="flex" flexDirection="column" ml="0px">
                    <SortArrows
                      i={enabled}
                      b="enabled"
                      desc="desc"
                      asc="asc"
                      handleOnClick={handleOnClick}
                    />
                  </Box>
                </Box>
              </Th>
              <Th>
                <Box as="p" color="#bdc1d0" fontSize="12px" fontFamily="Roboto">
                  Actions
                </Box>
              </Th>
            </Tr>
          </Thead>
        )}
        {loading && (
          <Box p={12} d="flex" alignItems="center" justifyContent="center" h="400px">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.500"
              size="xl"
            />
          </Box>
        )}
        {categories.length > 0 && !loading ? (
          <Tbody>
            {map(categories, (category) => {
              return (
                <Tr key={category.id}>
                  <Td maxWidth="100px">
                    <Box as="p" fontWeight="700" fontSize="16px" fontFamily="Roboto">
                      {category.code}
                    </Box>
                  </Td>
                  <Td>{category.name}</Td>
                  <Td>
                    <Badge colorScheme={category.enabled ? 'green' : 'red'}>
                      {category.enabled ? 'Enabled' : 'Disabled'}
                    </Badge>
                  </Td>
                  <Td>
                    <CostCategoryEdit
                      category={category}
                      updateCategory={updateCategory}
                    />
                    {category.enabled && (
                      <CostCategoryRemove
                        category={category}
                        removeCategory={removeCategory}
                      />
                    )}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        ) : categories.length === 0 && !loading ? (
          <Box
            d="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            p="80px"
          >
            <Box fontSize="18px" fontWeight="bold" mt="20px" mb="20px">
              No results.
            </Box>
            <Box color="#a9b1b4" fontSize="14px">
              We could not find any cost categories.
            </Box>
          </Box>
        ) : null}
      </Table>
      <Box margin="20px" />
      <Pagination
        handlePageSizeChange={handlePageSizeChange}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
        pagesQuantity={pagesQuantity}
      />
    </>
  );
}

export default CostCategoryList;
